let holderRender;
export function setHolderRender(render) {
    holderRender = render;
}
export function getHolderRender() {
    return holderRender;
}
/** Wrap static Modal / Message / Notification tree with ConfigProvider.config({ holderRender }). */
export function wrapWithHolderRender(node) {
    if (typeof holderRender === 'function') {
        return holderRender(node);
    }
    return node;
}
